import { ROLES } from "../const/roles"
import type { ApiRoleStrategy } from "../hooks"
import type { UploadedFile } from "../types"

export const laboratoryDataRefApiRoleConf: ApiRoleStrategy = {
  [ROLES.ADMIN]: {
    queryKey: ["laboratories", "dataref", "active"],
    endpoint: "/api/laboratories/dataref?active=true",
  },
  [ROLES.ADHERENT_HOLDER]: {
    queryKey: ["laboratories", "adherent", "dataref", "active"],
    endpoint: "/api/laboratories/adherent/dataref?active=true",
  },
  [ROLES.ADHERENT_TEAM]: {
    queryKey: ["laboratories", "adherent", "dataref", "active"],
    endpoint: "/api/laboratories/adherent/dataref?active=true",
  },
  [ROLES.ADHERENT_ADVISOR]: {
    queryKey: ["laboratories", "adherent", "dataref", "active"],
    endpoint: "/api/laboratories/adherent/dataref?active=true",
  },
  [ROLES.EXTERN_CONTACT_LABORATORY]: {
    queryKey: [],
    endpoint: "",
  },
}

export interface LaboratoriesDataRefApi {
  categories?: string[] | null
  id: number
  name: string
  ospharmCode?: number | null
  logo?: UploadedFile
}
